import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=85d28880&scoped=true"
import script from "./accountList.vue?vue&type=script&lang=js"
export * from "./accountList.vue?vue&type=script&lang=js"
import style0 from "./accountList.vue?vue&type=style&index=0&id=85d28880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d28880",
  null
  
)

export default component.exports